/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  ASSIGN_STOCK_LIST,
  UNASSIGN_STOCK,
} from "../../../repository/taskRepo";
import { getTeamMemberList } from "../../../repository/teamManagementRepo";
import moment from "moment";

const useAssignStock = () => {
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [assignStockList, setAssignStockList] = useState([]);
  const [uassignModal, setUnassignModal] = useState(false);
  const { InventoryD_Id } = useParams();
  const [assignedId, setAssignedId] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [assignedType, setAssignedType] = useState(null);
  const [formData, setFormData] = useState({
    remarks: "",
    quantity: "",
  });

  const [filter, setFilter] = useState({
    type: null,
    employee_id: null,
    startDateTime: null,
    endDateTime: null,
  });

  // const handleFilterChange = (e) =>{
  // const {name, value} = e.target
  //  setFilter((prev)=>({
  //    ...prev,
  //    [name]:value
  // }))
  // }

  const handleFilterChange = (eOrName, value) => {
    // Case 1: called from normal <input> or <select>
    if (eOrName?.target) {
      const { name, value } = eOrName.target;
      setFilter((prev) => ({ ...prev, [name]: value }));
    }
    // Case 2: called from DateInput (custom component)
    else if (typeof eOrName === "string") {
      setFilter((prev) => ({ ...prev, [eOrName]: value }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenModal = (id, type, data = {}) => {
    setUnassignModal(true);
    setAssignedId(id);
    setAssignedType(type);
    setFormData((prev) => ({
      ...prev,
      quantity: data?.assignQuantity || "",
    }));
  };
  const handleCloseModal = () => {
    setUnassignModal(false);
    setFormData({});
  };

  const handlePagination = (obj) => {
    setController(obj);
  };

  useEffect(() => {
    assignStockListAPI();
    employeeAssignListAPI();
  }, [controller.page, controller.rowsPerPage]);

  const handleSearchFilter = async () => {
    setController((prev) => ({ ...prev, page: 1 }));
    await assignStockListAPI();
  };

  // Reset filter
  const handleResetFilter = async () => {
    // define reset values
    const resetValues = {
      type: null,
      employee_id: null,
      startDateTime: null,
      endDateTime: null,
    };

    // set filter immediately
    setFilter(resetValues);

    // ensure controller resets
    setController((prev) => ({ ...prev, page: 1 }));

    // directly call API with reset values
    await assignStockListAPI(resetValues);
  };

  const assignStockListAPI = async (customFilter) => {
    try {
      const activeFilter = customFilter || filter;
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        isDeleted: false,
        inventory_id: InventoryD_Id,
        type: activeFilter.type || null,
        startDateTime:
          moment(activeFilter.startDateTime).startOf("day").utc() || null,
        endDateTime:
          moment(activeFilter.endDateTime).endOf("day").utc() || null,
        employee_id: activeFilter.employee_id || null,
      };

      setSpinner(true);
      let response = await ASSIGN_STOCK_LIST(payload);
      setAssignStockList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {}
    setSpinner(false);
  };

  const unAssignStock = async () => {
    try {
      let payloadType;
      if (assignedType === "ASSIGN") {
        payloadType = "ASSIGN";
      } else if (assignedType === "USE") {
        payloadType = "USE";
      } else {
        payloadType = assignedType;
      }

      let payload = {
        _id: assignedId,
        type: payloadType,
        remarks: formData.remarks,
        quantity: Number(formData.quantity) || 0,
      };

      setSpinner(true);
      let response = await UNASSIGN_STOCK(payload);
      if (response.code === 200) {
        toast.success(response.message || "Unassigned stock successfully");
        handleCloseModal();
        setFormData({});
        assignStockListAPI();
      } else {
        toast.error(response.message || "Unassign stock fail");
      }
    } catch (error) {
      toast.error(error?.message || "Unassign stock fail");
    } finally {
      setSpinner(false);
    }
  };

  const employeeAssignListAPI = async () => {
    try {
      let payload = {
        page: 1,
        count: 1000,
        isDeleted: false,
        isActive: true,
      };

      setSpinner(true);
      let response = await getTeamMemberList(payload);
      setEmployeeList(response?.data);
    } catch (error) {}
    setSpinner(false);
  };

  return {
    data: {
      spinner,
      controller,
      totalCount,
      assignStockList,
      uassignModal,
      formData,
      employeeList,
      filter,
    },
    methods: {
      handlePagination,
      handleOpenModal,
      handleCloseModal,
      unAssignStock,
      handleChange,
      handleFilterChange,
      setFilter,
      handleSearchFilter,
      handleResetFilter,
    },
  };
};

export default useAssignStock;
